import {
  ChangeDetectionStrategy,
  Component,
  Input,
  output,
  ViewChild
} from '@angular/core';
import { Popover, PopoverModule } from 'primeng/popover';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'm-overlaypanel',
  imports: [PopoverModule],
  templateUrl: './m-overlaypanel.component.html',
  styleUrls: ['./m-overlaypanel.component.scss']
})
export class MOverlayPanelComponent {
  @ViewChild('popover') popover!: Popover;

  @Input() baseZIndex = 0;
  @Input() customClass = 'm-overlaypanel';
  @Input() dismissable = true;
  /** @deprecated no-op — PrimeNG 19 Popover removed the close icon; panels close via dismissable/hide() */
  @Input() showCloseIcon = false;
  @Input() appendTo: string | HTMLElement = 'body';

  readonly panelShow = output<void>();
  readonly panelHide = output<void>();

  showPanel(event: Event) {
    this.popover.show(event);
  }

  hidePanel() {
    this.popover.hide();
  }
}
